import "../../styles/pageskelton.css";
import SkeletonBox from "./SkeletonBox";

const ContactSkeleton = () => (
  <div className="sk-page">
    <SkeletonBox className="sk-header" />
    <SkeletonBox className="sk-inner-hero" />

    <div className="conatiner">
      {/* 4 info cards row */}
      <div className="sk-contact-grid">
        {[1, 2, 3, 4].map((i) => (
          <SkeletonBox key={i} className="sk-contact-card" />
        ))}
      </div>

      {/* Map + Form */}
      <div className="sk-contact-body">
        <SkeletonBox className="sk-contact-map" />
        <div>
          <SkeletonBox className="sk-section-title" style={{ marginBottom: 24, marginLeft: 0 }} />
          {[1, 2, 3, 4].map((i) => (
            <SkeletonBox key={i} className="sk-form-field" />
          ))}
          <SkeletonBox className="sk-form-btn" />
        </div>
      </div>
    </div>
  </div>
);

export default ContactSkeleton;
